import { createThunkRoutine } from 'redux-thunk-routine';

export const FetchUsersRoutine = createThunkRoutine('users/FETCH_USERS');
export const FetchWelldesignUsersRoutine  = createThunkRoutine('users/FETCH_WELLDESIGN_USERS');
export const FetchExternalUsersRequestsRoutine = createThunkRoutine('users/FETCH_EXTERNAL_USERS_REQUESTS');
export const CreateExternalUserByRequestRoutine = createThunkRoutine('users/CREATE_EXTERNAL_USER_BY_REQUEST');
export const RejectExternalUserRequestRoutine = createThunkRoutine('users/REJECT_EXTERNAL_USER_REQUEST');